import { Box, Grid2 } from '@mui/material';
import { Link } from 'react-router-dom';
import { calculateCreatedAgo } from '../../../components/commonFunc';
import { getHubItemHref, isExternalHubHref } from '../helper/hubItemHref';
import { HubFeaturedBannerImage } from './HubFeaturedBannerImage';

const featuredLinkClassName = 'group block no-underline text-inherit cursor-pointer';

export const HubFeatureCard = ({ firstBlog, to }) => {
  const href = to ?? getHubItemHref(firstBlog);

  const content = (
    <Grid2 container spacing={2}>
      <Grid2
        size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}
        className="relative text-start text-white rounded-2xl"
        display="flex"
        flexDirection="column"
        justifyContent="end"
        alignItems="flex-start"
      >
        <div className="relative w-full max-w-full overflow-hidden rounded-2xl">
          <HubFeaturedBannerImage
            mediaPath={firstBlog?.postMedia}
            title={firstBlog?.title}
            postType={firstBlog?.postType}
          />

          <Box
            sx={{ background: 'linear-gradient(0deg, #22c0b1, #22c0b1, #ffffff00)' }}
            className="absolute bottom-0 w-full rounded-b-2xl p-4 sm:p-6"
          >
            <h4 className="cursor-pointer text-2xl font-medium leading-tight sm:text-3xl sm:leading-snug md:text-[42px] md:leading-[54.6px]">
              {firstBlog?.title}
            </h4>
            <Box
              className="cursor-pointer w-full py-2 sm:py-3 flex flex-col gap-1 sm:flex-row sm:gap-6"
            >
              <span>{calculateCreatedAgo(firstBlog)}</span>
              <span>By Charlee.ai</span>
            </Box>
          </Box>
        </div>
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}>
        <p className="line-clamp-[8] text-sm leading-relaxed sm:line-clamp-[12] sm:text-base">
          {firstBlog?.content}
        </p>
      </Grid2>
    </Grid2>
  );

  if (!href) {
    return content;
  }

  if (isExternalHubHref(href)) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={featuredLinkClassName}
      >
        {content}
      </a>
    );
  }

  return (
    <Link to={href} className={featuredLinkClassName}>
      {content}
    </Link>
  );
};
